import { Graph } from "@antv/x6"


function getPorts() {
  const ports = {
    groups: {
      top: {
        position: 'top',
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: '#5F95FF',
            strokeWidth: 1,
            fill: '#000',
            style: {
              visibility: 'hidden',
            },
            event: 'port:click:top',
          },
        },
      },
      right: {
        position: 'right',
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: '#5F95FF',
            strokeWidth: 1,
            fill: '#000',
            style: {
              visibility: 'hidden',
            },
            event: 'port:click:right',
          },
        },
      },
      bottom: {
        position: 'bottom',
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: '#5F95FF',
            strokeWidth: 1,
            fill: '#000',
            style: {
              visibility: 'hidden',
            },
            event: 'port:click:bottom',
          },
        },
      },
      left: {
        position: 'left',
        attrs: {
          circle: {
            r: 4,
            magnet: true,
            stroke: '#5F95FF',
            strokeWidth: 1,
            fill: '#000',
            style: {
              visibility: 'hidden',
            },
            event: 'port:click:left',
          },
        },
      },
    },
    items: [
      {
        group: 'top',
      },
      {
        group: 'right',
      },
      {
        group: 'bottom',
      },
      {
        group: 'left',
      },
    ],
  }

  return ports
}




/**
 * 注册自定义节点
 */
export function registerNode() {

  const ports = getPorts()

  Graph.registerNode(
    'custom-rect',
    {
      inherit: 'rect',
      width: 66,
      height: 36,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF',
        },
        text: {
          fontSize: 12,
          textAnchor: 'middle',
          color: '#000',
        },
      },
      ports: { ...ports },
    },
    true,
  )

  Graph.registerNode(
    'custom-polygon',
    {
      inherit: 'polygon',
      width: 66,
      height: 36,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF',
        },
        text: {
          fontSize: 12,
          color: '#262626',
        },
      },
      ports: {
        ...ports,
        items: [
          {
            group: 'top',
          },
          {
            group: 'bottom',
          },
        ],
      },
    },
    true,
  )

  Graph.registerNode(
    'custom-circle',
    {
      inherit: 'circle',
      width: 45,
      height: 45,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF',
        },
        text: {
          fontSize: 12,
          textAnchor: 'middle',
          color: '#262626',
        },
      },
      ports: { ...ports },
    },
    true,
  )

  Graph.registerNode(
    'custom-image',
    {
      inherit: 'image',
      width: 52,
      height: 52,
      markup: [
        {
          tagName: 'rect',
          selector: 'body',
        },
        {
          tagName: 'image',
        },
        {
          tagName: 'text',
          selector: 'label',
        },
      ],
      attrs: {
        body: {
          stroke: '#5F95FF',
          fill: 'none',

        },
        image: {
          style: {
            userSelect: 'none'
          }
        },
        label: {
          refY: '-15',
          textAnchor: 'middle',
          textVerticalAnchor: 'top',
          fontSize: 12,
          fill: '#000',
        },
      },
      ports: { ...ports },
    },
    true,
  )

  Graph.registerNode(
    'custom-text',
    {
      inherit: 'text-block',
      width: 70,
      height: 20,
      markup: [
        {
          tagName: 'rect',
          selector: 'body',
        },
        {
          tagName: 'text',
          selector: 'label',
        },
      ],
      attrs: {
        body: {
          stroke: 'none',
          fill: 'none',
        },
        label: {
          refX: 3,
          refY: 2,
          textAnchor: 'middle',
          textVerticalAnchor: 'top',
          fontSize: 14,
          stroke: '#000',
          fill:'none'
        },
      },
      ports: { ...ports },
    },
    true,
  )

  Graph.registerNode('meter-node', {
    inherit: 'image',
    width: 52,
    height: 52,
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'image',
        // selector: 'img',
      },
      {
        tagName: 'text',
        selector: 'label',
      },
      {
        tagName: 'text',
        selector: 'power',
      },
      {
        tagName: 'text',
        selector: 'voltage',
      },
      {
        tagName: 'text',
        selector: 'current',
      },
      {
        tagName: 'text',
        selector: 'q',
      },
    ],
    attrs: {
      body: {
        stroke: '#5F95FF',
        fill: 'none',

      },
      image: {
        style: {
          userSelect: 'none'
        }
        // width: 26,
        // height: 26,
        // refX: 13,
        // refY: 16,
      },
      label: {
        // refX: -25,
        refY: -15,
        textAnchor: 'middle',
        textVerticalAnchor: 'top',
        fontSize: 12,
        fill: '#000',
      },
      power: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-20',
      },
      voltage: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-5',
      },
      current: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '10',
      },
      q: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '25',
      }
    },
    ports: { ...ports },
  }, true)

  Graph.registerNode('elink-node', {
    inherit: 'image',
    width: 52,
    height: 52,
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'image',
      },
      {
        tagName: 'text',
        selector: 'label',
      },
      {
        tagName: 'text',
        selector: 'power',
      },
      {
        tagName: 'text',
        selector: 'soc',
      },
    ],
    attrs: {
      body: {
        stroke: '#5F95FF',
        fill: 'none',

      },
      image: {
        style: {
          userSelect: 'none'
        }
        // width: 26,
        // height: 26,
        // refX: 13,
        // refY: 16,
      },
      label: {
        refY: '-15',
        textAnchor: 'middle',
        textVerticalAnchor: 'top',
        fontSize: 12,
        fill: '#000',
      },
      power: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-15',
      },
      soc: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '0',
      },
    },
    ports: { ...ports },
  }, true)
  
  Graph.registerNode('eblock-node', {
    inherit: 'image',
    width: 52,
    height: 52,
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'image',
      },
      {
        tagName: 'text',
        selector: 'label',
      },
      {
        tagName: 'text',
        selector: 'status',
      },
      {
        tagName: 'text',
        selector: 'power',
      },
      {
        tagName: 'text',
        selector: 'voltage',
      },
      {
        tagName: 'text',
        selector: 'current',
      },
      {
        tagName: 'text',
        selector: 'soc',
      },
    ],
    attrs: {
      body: {
        stroke: '#5F95FF',
        fill: 'none',

      },
      image: {
        style: {
          userSelect: 'none'
        }
        // width: 26,
        // height: 26,
        // refX: 13,
        // refY: 16,
      },
      label: {
        refY: '-15',
        textAnchor: 'middle',
        textVerticalAnchor: 'top',
        fontSize: 12,
        fill: '#000',
      },
      status: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-30',
      },
      power: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-15',
      },
      soc: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '0',
      },
      voltage: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '15',
      },
      current: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '30',
      }
    },
    ports: { ...ports },
  }, true)

  Graph.registerNode('transformer-node', {
    inherit: 'image',
    width: 52,
    height: 52,
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'image',
      },
      {
        tagName: 'text',
        selector: 'label',
      },
      {
        tagName: 'text',
        selector: 'capacity',
      },
      {
        tagName: 'text',
        selector: 'temp',
      },
      {
        tagName: 'text',
        selector: 'temp_a',
      },
      {
        tagName: 'text',
        selector: 'temp_b',
      },
      {
        tagName: 'text',
        selector: 'temp_c',
      },
    ],
    attrs: {
      body: {
        stroke: '#5F95FF',
        fill: 'none',

      },
      image: {
        style: {
          userSelect: 'none'
        }
        // width: 26,
        // height: 26,
        // refX: 13,
        // refY: 16,
      },
      label: {
        refY: '-15',
        textAnchor: 'middle',
        textVerticalAnchor: 'top',
        fontSize: 12,
        fill: '#000',
      },
      capacity: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-30',
      },
      temp: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '-15',
      },
      temp_a: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '0',
      },
      temp_b: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '15',
      },
      temp_c: {
        fontSize: 12,
        fill: '#000',
        textAnchor: 'right',
        x: '30',
        y: '30',
      },      
    },
    ports: { ...ports },
  }, true)


  Graph.registerNode('bus-node', {
    inherit: 'rect',
    width: 66,
    height: 36,
    markup: [
      {
        tagName: 'rect', // 标签名称
        selector: 'body', // 选择器
      },
      // {
      //   tagName: 'polygon',
      //   selector: 'arrow',
      //   attrs: {
      //     points: '10,0 30,0 30,20 40,20 20,40 0,20 10,20',
      //   }
      // },
      {
        tagName: 'text',
        selector: 'label',
      },
    ],
    attrs: {
      body: {
        strokeWidth: 1,
        stroke: '#5F95FF',
        fill: '#EFF4FF',
      },
      label: {
        fontSize: 12,
        textAnchor: 'middle',
        color: '#000',
      },
      arrow: {
        fill: '#00f',
        transform: 'translate(20, 8)',
      }
    },

    ports: { ...ports },
    // ports: {
    //   groups: {
    //     group1: {
    //       position: {
    //         name: 'absolute',
    //         args: { x: 0, y: 0 },
    //       },
    //       attrs: {
    //         circle: {
    //           r: 4,
    //           magnet: true,
    //           stroke: '#f00',
    //           strokeWidth: 1,
    //           fill: '#000',
    //           style: {
    //             visibility: 'hidden',
    //           },
    //           // event: 'port:click:group1',
    //         },
    //       },
    //     },
    //   },

    // },
  }, true)


}
